import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, MDBTable, MDBTableHead, MDBTableBody } from "mdbreact";
import { muaStatic, site } from "../config/api";

import Picpresent from "../assets/images/ad_present.jpg";
import PicNews from "../assets/images/ad_news.png";
import PicCalendar from "../assets/images/ad_calenda.png";
import PicStep from "../assets/images/ad_step.png";
import PicScholarship from "../assets/images/ad_scholarship.jpg";
import PicProcedurePresent from "../assets/images/ad_steppresent.jpg";
import MetaTags from "react-meta-tags";
import publishimg from "../assets/publishimg.jpg";
import publishimg2 from "../assets/publishimg2.jpg";
import publishimg3 from "../assets/publishimg3.png";

export default class Home extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modalshow: false
        }
        this.modalshow_close = this.modalshow_close.bind(this);
    }

    modalshow_close(event) {
        this.setState({ modalshow: false });
    }

    render() {
        return (<>
            <MetaTags>
                <title>หน้าแรกระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร</title>
                <meta name="description" content="หน้าแรกระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University" />
                <meta property="og:title" content="หน้าแรกระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร" />
                <meta property="og:image" content="../../public/favicon.ico" />
            </MetaTags>
            <br />
            <MDBContainer fluid >
                <MDBTable striped>
                    <MDBTableHead>
                        <tr>
                            <th><button className="mr-1">dddd</button><button className="mr-1">dddd</button><button className="mr-1">dddd</button><button className="mr-1">dddd</button></th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        <tr>
                            <td><li>คลิกเพื่อดู ประกาศการรับสมัครนักศึกษาเข้าศึกษาต่อหลักสูตรประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู รอบ 2 ประจำปีการศึกษา 2565 <a className="text-success" href={muaStatic + "/imagesbg/publishregister_kru_2565_rob2.pdf"} target="_blank"><u><blink>อ่านต่อ</blink></u></a></li></td>
                        </tr>
                        <tr>
                            <td><li>คลิกเพื่อดู ประกาศการรับสมัครนักศึกษาเข้าศึกษาต่อหลักสูตรประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู ประจำปีการศึกษา 2565 <a className="text-success" href={muaStatic + "/imagesbg/publishregister_kru_2565.pdf"} target="_blank"><u><blink>อ่านต่อ</blink></u></a></li></td>
                        </tr>
                        <tr>
                            <td><li>คลิกเพื่อดู ประกาศรับสมัครสอบคัดเลือกเข้าศึกษาต่อระดับบัณฑิตศึกษา ประจำปีการศึกษา 2565 <a className="text-success" href={muaStatic + "/imagesbg/publishregister_graduates.pdf"} target="_blank"><u><blink>อ่านต่อ</blink></u></a></li></td>
                        </tr>
                        <tr>
                            <td className="text-right text-primary"><a className="btn btn-primary" href={`${process.env.REACT_APP_BASENAME || ""}/News`}><u>ดูเพิ่มเติม</u></a></td>
                        </tr>
                    </MDBTableBody>
                </MDBTable>
                <MDBRow className="mt-2">
                    {/* <MDBCol className="mt-2" lg="3" md="4" sm="5">
                            <MDBRow className="mt-2">
                                <MDBCol className="mt-2">
                                    <h3 class="heading font-x3">ประกาศรับสมัคร</h3>
                                    <p class="btmspace-30">ประกาศรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร <a href={`${process.env.REACT_APP_BASENAME || ""}/Publishregister`}>[&hellip;]</a></p>
                                    <footer><a class="btn #fb8c00 orange darken-1" href={`${process.env.REACT_APP_BASENAME || ""}/Publishregister`}>อ่านเพิ่มเติม &raquo;</a></footer>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-2">
                                <MDBCol className="mt-2">
                                    <h3 class="heading font-x3">ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์</h3>
                                    <p class="btmspace-30">ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์มหาวิทยาลัยราชภัฏกำแพงเพชร <a href={`${process.env.REACT_APP_BASENAME || ""}/Publishinterview`}>[&hellip;]</a></p>
                                    <footer><a class="btn #fb8c00 orange darken-1" href={`${process.env.REACT_APP_BASENAME || ""}/Publishinterview`}>อ่านเพิ่มเติม &raquo;</a></footer>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-2">
                                <MDBCol className="mt-2">
                                    <h3 class="heading font-x3">ประกาศรายชื่อผู้มีสิทธิ์รายงานตัว</h3>
                                    <p class="btmspace-30">ประกาศรายชื่อผู้มีสิทธิ์รายงานตัวมหาวิทยาลัยราชภัฏกำแพงเพชร <a href={`${process.env.REACT_APP_BASENAME || ""}/Publishpresent`}>[&hellip;]</a></p>
                                    <footer><a class="btn #fb8c00 orange darken-1" href={`${process.env.REACT_APP_BASENAME || ""}/Publishpresent`}>อ่านเพิ่มเติม &raquo;</a></footer>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-2">
                                <MDBCol className="mt-2">
                                    <h3 class="heading font-x3">ประกาศแจ้งกำหนดการเปลี่ยนแปลงสาขาวิชาที่ไม่เปิดการเรียนการสอน</h3>
                                    <p class="btmspace-30">ประกาศแจ้งกำหนดการเปลี่ยนแปลงสาขาวิชาที่ไม่เปิดการเรียนการสอนมหาวิทยาลัยราชภัฏกำแพงเพชร <a href={muaStatic + "/imagesbg/registerchangmajor.pdf"} target="_blank">[&hellip;]</a></p>
                                    <footer><a class="btn #fb8c00 orange darken-1" href={muaStatic + "/imagesbg/registerchangmajor.pdf"} target="_blank">อ่านเพิ่มเติม &raquo;</a></footer>
                                </MDBCol>
                            </MDBRow>
                        </MDBCol> 
                         <MDBCol className="mt-2" lg="9" md="8" sm="7"> */}
                    <MDBCol className="mt-2" lg="12" md="12" sm="12">
                        <MDBRow className="mt-2">


                            <MDBCol className="mt-2" lg="4" md="8" sm="7">
                                <h3 class="heading">การรายงานตัวเข้าเป็นนักศึกษาใหม่ ภาคปกติ (กำแพงเพชรและแม่สอด) <br /><a href={muaStatic + "/imagesbg/publishpresentnew.pdf"} target="_blank">> PRESENTS</a></h3>
                                <img class="btmspace-15" src={Picpresent} alt="" /><br />
                                <span class="btmspace-30">การรายงานตัวเข้าเป็นนักศึกษาใหม่ ภาคปกติ (กำแพงเพชรและแม่สอด) มหาวิทยาลัยราชภัฏกำแพงเพชร <a href={muaStatic + "/imagesbg/publishpresentnew.pdf"} target="_blank">[&hellip;]</a></span>
                                <footer><a href={muaStatic + "/imagesbg/publishpresentnew.pdf"} target="_blank">อ่านเพิ่มเติม &raquo;</a></footer>
                            </MDBCol>

                            <MDBCol className="mt-2" lg="4" md="8" sm="7">
                                <h3 class="heading">ข่าวประชาสัมพันธ์ <br /><a href={`${process.env.REACT_APP_BASENAME || ""}/News`}>> News</a></h3>
                                <img class="btmspace-15" src={PicNews} alt="" /><br />
                                <span class="btmspace-30">ข่าวประชาสัมพันธ์มหาวิทยาลัยราชภัฏกำแพงเพชร <a href={`${process.env.REACT_APP_BASENAME || ""}/News`}>[&hellip;]</a></span>
                                <footer><a href={`${process.env.REACT_APP_BASENAME || ""}/News`}>อ่านเพิ่มเติม &raquo;</a></footer>
                            </MDBCol>
                            <MDBCol className="mt-2" lg="4" md="8" sm="7">
                                <h3 class="heading">ปฏิทินการรับสมัคร <br /><a href={`${process.env.REACT_APP_BASENAME || ""}/Calendars`}> Calendar</a></h3>
                                <img class="btmspace-15" src={PicCalendar} alt="" /><br />
                                <span class="btmspace-30">ปฏิทินการรับสมัครนักศึกษามหาวิทยาลัยราชภัฏกำแพงเพชร <a href={`${process.env.REACT_APP_BASENAME || ""}/Calendars`}>[&hellip;]</a></span>
                                <footer><a href={`${process.env.REACT_APP_BASENAME || ""}/Calendars`}>อ่านเพิ่มเติม &raquo;</a></footer>
                            </MDBCol>
                            <MDBCol className="mt-2" lg="4" md="8" sm="7">
                                <h3 class="heading">ขั้นตอนการสมัคร <br /><a href={`${process.env.REACT_APP_BASENAME || ""}/Procedureregister`}> STEP</a></h3>
                                <img class="btmspace-15" src={PicStep} alt="" /><br />
                                <span class="btmspace-30">ขั้นตอนการสมัครเรียนมหาวิทยาลัยราชภัฏกำแพงเพชร <a href={`${process.env.REACT_APP_BASENAME || ""}/Procedureregister`}>[&hellip;]</a></span>
                                <footer><a href={`${process.env.REACT_APP_BASENAME || ""}/Procedureregister`}>อ่านเพิ่มเติม &raquo;</a></footer>
                            </MDBCol>
                            <MDBCol className="mt-2" lg="4" md="8" sm="7">
                                <h3 class="heading">ขั้นตอนการกู้ยืมเงินกองทุนเงินให้กู้ยืมเพื่อการศึกษา (กยศ.) <br /><a href={`${process.env.REACT_APP_BASENAME || ""}/Scholarship`}> Scholarships</a></h3>
                                <img class="btmspace-15" src={PicScholarship} alt="" /><br />
                                <span class="btmspace-30">ขั้นตอนการกู้ยืมเงินกองทุนเงินให้กู้ยืมเพื่อการศึกษา (กยศ.) มหาวิทยาลัยราชภัฏกำแพงเพชร <a href={`${process.env.REACT_APP_BASENAME || ""}/Scholarship`}>[&hellip;]</a></span>
                                <footer><a href={`${process.env.REACT_APP_BASENAME || ""}/Scholarship`}>อ่านเพิ่มเติม &raquo;</a></footer>
                            </MDBCol>
                            {/* <MDBCol className="mt-2" lg="4" md="8" sm="7">
                                    <h3 class="heading">ขั้นตอนการกู้ยืมเงินกองทุนเงินให้กู้ยืมเพื่อการศึกษา (กยศ.) <br /><a href={muaStatic + "/imagesbg/guide_scholarship.pdf"} target="_blank">> Scholarships</a></h3>
                                    <img class="btmspace-15" src={PicScholarship} alt="" /><br />
                                    <span class="btmspace-30">ขั้นตอนการกู้ยืมเงินกองทุนเงินให้กู้ยืมเพื่อการศึกษา (กยศ.) มหาวิทยาลัยราชภัฏกำแพงเพชร <a href={muaStatic + "/imagesbg/guide_scholarship.pdf"} target="_blank">[&hellip;]</a></span>
                                    <footer><a href={muaStatic + "/imagesbg/guide_scholarship.pdf"} target="_blank">อ่านเพิ่มเติม &raquo;</a></footer>
                                </MDBCol> */}
                            <MDBCol className="mt-2" lg="4" md="8" sm="7">
                                <h3 class="heading">ขั้นตอนการรายงานตัวเป็นนักศึกษา <br /><a href={`${process.env.REACT_APP_BASENAME || ""}/ProcedurePresent`}>> STEP PRESENTS</a></h3>
                                <img class="btmspace-15" src={PicProcedurePresent} alt="" /><br />
                                <span class="btmspace-30">ขั้นตอนการรายงานตัวเป็นนักศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร <a href={`${process.env.REACT_APP_BASENAME || ""}/ProcedurePresent`}>[&hellip;]</a></span>
                                <footer><a href={`${process.env.REACT_APP_BASENAME || ""}/ProcedurePresent`}>อ่านเพิ่มเติม &raquo;</a></footer>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>

            <MDBModal isOpen={this.state.modalshow} toggle={this.modalshow_close} centered dark size="lg" closeButton >
                <MDBModalHeader toggle={this.modalshow_close}>
                    ประกาศมหาวิทยาลัยราชภัฏกำแพงเพชร
                </MDBModalHeader>
                <MDBModalBody className="#bdbdbd grey lighten-1">
                    <img src={publishimg3} width="100%" />
                    {/* มหาวิทยาลัยจะประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ เวลา 18.00 น. ที่เว็บไซต์ https://admission.kpru.ac.th
                        มหาวิทยาลัยราชภัฏกำแพงเพชร จะประกาศรายชื่อผู้มีสิทธิ์เข้าศึกษาภาคปกติ (กำแพงเพชรแม่สอด) รอบ 2 เวลา 18.00 น. */}
                    {/* มหาวิทยาลัยฯ จะประกาศรายชื่อผู้มีสิทธิ์เข้าศึกษาภาคปกติ หลักสูตรพยาบาลศาสตรบัณฑิต ประจำปีการศึกษา 2565 ในวันที่ 7 มีนาคม 2565 เวลา 10.00 น.  ที่เว็บไซต์ https://admission.kpru.ac.th */}
                </MDBModalBody>
                <MDBModalFooter>
                    <button class="btn btn-danger btn-md" onClick={this.modalshow_close}>ปิด</button>
                </MDBModalFooter>
            </MDBModal>

        </>)
    }
}

